<template>
    <div class="configurator-preselector">
        <PreselectorStep class="preselector-step" name="make" order="first" title="Marke" priority="Audi,BMW,VW,Mercedes Benz,Opel" />
        <PreselectorStep class="preselector-step" name="model" order="second" title="Modell" />
        <PreselectorStep class="preselector-step" name="year" order="third" title="Erstzulassung (Jahr)" />
    </div>
</template>
<script>
import PreselectorStep from "./PreselectorStep";

export default {
    name: "Preselector",
    components: {
        PreselectorStep
    }
}
</script>
<style lang="scss" scoped>
    @import "~@/assets/vars";

    .configurator-preselector {
        @include breakpoint(fromlarge) {
            width:75%;
            display: flex;
            justify-content: space-between;
            gap:20px;
        }
        @include breakpoint(extralarge) {
            gap:40px;
        }
        .preselector-step {
            margin-bottom:16px;
            @include breakpoint(fromlarge) {
                width: 33%;
                margin-bottom:0;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/local-components/Preselector.vue